import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ShapeIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M42.657 0c2.927-.023 5.32 2.294 5.343 5.175a5.161 5.161 0 0 1-1.518 3.706 5.309 5.309 0 0 1-2.618 1.429v27.458c.3.065.599.156.89.275C46.72 38.844 48 40.732 48 42.825c-.027 2.847-2.365 5.148-5.257 5.175-2.127 0-4.044-1.26-4.858-3.195a5.12 5.12 0 0 1-.28-.877H10.47c-.529 2.316-2.62 4.05-5.129 4.072-2.903 0-5.257-2.318-5.257-5.176 0-2.48 1.772-4.551 4.136-5.057v-27.44C1.827 9.838.02 7.76 0 5.257-.023 2.378 2.33.023 5.257 0c2.542-.02 4.68 1.725 5.214 4.072h27.057C38.055 1.758 40.145.02 42.658 0zm.086 39.855c-1.666 0-3.017 1.329-3.018 2.969 0 1.64 1.35 2.97 3.017 2.97 1.666 0 3.017-1.329 3.017-2.969-.005-1.638-1.352-2.964-3.016-2.97zm-37.402 0c-1.666 0-3.016 1.33-3.016 2.97 0 1.64 1.35 2.97 3.017 2.97 1.666 0 3.016-1.33 3.017-2.97-.006-1.638-1.353-2.965-3.018-2.97zm32.17-33.577H10.49a5.178 5.178 0 0 1-1.41 2.603 5.294 5.294 0 0 1-1.953 1.237 5.51 5.51 0 0 1-.666.196v27.453l.175.04c1.921.48 3.42 2 3.843 3.915h27.043c.463-1.995 2.064-3.541 4.1-3.959V10.326a5.33 5.33 0 0 1-.443-.11l-.024-.008a3.553 3.553 0 0 1-.179-.056l-.058-.02a5.218 5.218 0 0 1-3.217-3.177l-.01-.028a5.083 5.083 0 0 1-.182-.65zM5.34 2.206a3.053 3.053 0 0 0-2.184.843 2.957 2.957 0 0 0-.916 2.126c-.01.812.314 1.594.898 2.169a3.093 3.093 0 0 0 2.202.884c1.647-.021 2.976-1.322 3.017-2.933.002-.04.002-.08 0-.12l.001.042c0-1.647-1.344-2.989-3.018-3.011zm37.402 0a3.053 3.053 0 0 0-2.185.843 2.957 2.957 0 0 0-.917 2.126 2.996 2.996 0 0 0 .899 2.169 3.093 3.093 0 0 0 2.203.884c1.672-.023 3.016-1.364 3.016-3.01 0-1.648-1.344-2.989-3.016-3.012z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ShapeIcon.propTypes = propTypes;

export default ShapeIcon;
